/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


import {ApiV0} from "../../api.v0";
import {RestApiService} from "../../../rest-api.service";
import {NewsFeedCreateUpdateReq, NewsFeedRes} from '../../../../contracts/v0/cp';
import {ExpandableProductDetails} from '../Core/api.v0.products';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export class ApiV0News {
    segment = '/news';

    // @ts-ignore
    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(searchModel:SearchModel = new SearchModel({})): Observable<BaseCollectionModel<NewsFeedRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<NewsFeedRes>>(
            `${this.segment}/search`,
            NewsFeedRes,
            searchModel
        );
    }

    add(dto: NewsFeedCreateUpdateReq): Observable<NewsFeedRes> {
        return this.rest.post<NewsFeedCreateUpdateReq, NewsFeedRes>(
            `${this.segment}/`,
            NewsFeedRes,
            dto
        );
    }

    update(id: string, dto: NewsFeedCreateUpdateReq) {
        return this.rest.patch<NewsFeedCreateUpdateReq, NewsFeedRes>(
            `${this.segment}/${id}`,
            NewsFeedRes,
            dto
        );
    }

    delete(source: NewsFeedRes) {
        return this.rest.delete(
            `${this.segment}/${source.id}`,
        );
    }

    details(id: string) {

        const defaultProductExpandFields: ExpandableProductDetails[] = [
            'Title.Translations', 'Text.Translations']

        return this.rest.get<NewsFeedRes>(
            `${this.segment}/${id}`,
            NewsFeedRes,
            {
                params: {
                    "expandFields": defaultProductExpandFields.join(','),
                }
            }
        );

    }
}
